import { transformCurrencyAmountDto } from './currency-amount';
import { transformItemPhotoDto } from './item';
export const transformMyOrderDto = _ref => {
  let {
    conversation_id,
    date,
    photo,
    price,
    status,
    title,
    transaction_user_status
  } = _ref;
  return {
    conversationId: conversation_id,
    date,
    photo: photo ? transformItemPhotoDto(photo) : null,
    price: transformCurrencyAmountDto(price),
    status,
    title,
    transactionUserStatus: transaction_user_status
  };
};